export const environment = {
  production: true,
  hmr: false,
  apiUrl: "https://utrav-api.my-officeapps.com",
  graphqlUrl: "https://utrav-api.my-officeapps.com",
  graphqlWs: "wss://utrav-api.my-officeapps.com",
  vapikey:
    "BCEpByHPcOZnzamamOYkA8keuE-GnjlGzEEVckfZuPFweopl0Gi3chbPQKTdk777-usXLB5i2ZuNn2vkIKqBg78",
  firebase: {
    apiKey: "AIzaSyCWmrbRSaBzTZSd3sbTRy-Ct_CS3jJvgEg",
    authDomain: "messaging-project-flutter.firebaseapp.com",
    projectId: "messaging-project-flutter",
    storageBucket: "messaging-project-flutter.firebasestorage.app",
    messagingSenderId: "304283923078",
    appId: "1:304283923078:web:4ee54b714f4c70411a1707",
  },
};
